import styled from 'styled-components'

export const Container = styled.div`
  flex: 1;

  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;

  padding: 24px 16px;
  box-sizing: border-box;
`

export const FooterSeparator = styled.div`
  height: 1px;
  background-color: var(--border-neutral-faded, #dfe2ea);
  width: 100%;
  margin-top: 8px;
`

export const DeleteButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  padding: 8px;
  box-sizing: border-box;

  background: var(--background-elevation-base, #fff);

  cursor: pointer;
`

export const DeleteButtonIcon = styled.img``

export const DeleteButtonLabel = styled.div`
  color: var(--foreground-critical, var(--foreground-critical, #cb101d));

  /* Body 3/Medium */
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`
